<div class="file-info-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">File Information</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="closeDialog()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <app-file-info [fileData]="file"></app-file-info>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="closeDialog()">Cancel</button>
  </div>
</div>
